// removed by extract-text-webpack-plugin
module.exports = {"block":"general__block___1-5wx borderRadius-m c-white display-inlineBlock fontSize-m lineHeight-copy paddingLeftRight-m paddingTopBottom-s textAlign-center"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-message-block/MessageBlock/style/general.css
// module id = 203
// module chunks = 0 28